import "core-js/modules/es.string.link.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/0fc7d20532fdaf769a25683617711png.png';
var _hoisted_1 = {
  "class": "col-xl-4 col-lg-4 col-md-6 order-xl-2 mb-0 mb-xl-0"
};
var _hoisted_2 = {
  "class": "card card-profile shadow"
};
var _hoisted_3 = {
  "class": "p-2"
};

var _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_avatar = _resolveComponent("el-avatar");

  var _component_el_col = _resolveComponent("el-col");

  var _component_el_row = _resolveComponent("el-row");

  var _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
    to: $data.link
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_row, {
        gutter: 24
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 3,
            "class": "text-left"
          }, {
            "default": _withCtx(function () {
              return [_createVNode(_component_el_avatar, {
                size: 40,
                src: $data.headImg,
                onError: _ctx.errorHandler
              }, {
                "default": _withCtx(function () {
                  return [_hoisted_4];
                }),
                _: 1
              }, 8, ["src", "onError"])];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString($props.communities[1]), 1)]), _createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString($props.communities[0]), 1)])];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            "default": _withCtx(function () {
              return [_createTextVNode(_toDisplayString($props.communities[2]), 1)];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["to"])])])]);
}